import { render, staticRenderFns } from "./DriversOccupancySuggestedCourseRow.vue?vue&type=template&id=fbfdd1b4&"
import script from "./DriversOccupancySuggestedCourseRow.vue?vue&type=script&lang=js&"
export * from "./DriversOccupancySuggestedCourseRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports